import CustomInputField from "../../../../common/CustomInputField";
import CustomDropdown from "../../../../common/CustomDropdown";
import { Formik, Form, Field, ErrorMessage } from "formik";
import CustomTextArea from "../../../../common/CustomTextArea";
import React, { useEffect, useState } from "react";
import { getZoon, listUserType, updateUser } from "../../../../api/login/Login";
import { toast } from "react-toastify";

function BasicDetails({ validate, business, value, handleInput_A, userId, refreshData }) {
  const [data, setData] = useState();
  const [userData, setuserData] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [businessData, setBusinessData] = useState({
    shop_name: "",
    business_Address: "",
    business_Area: "",
    business_city: "",
    business_pincode: "",
  });

  useEffect(() => {
    if (business) {
      setBusinessData({
        shop_name: business?.shop_name || "",
        business_Address: business?.business_Address || "",
        business_Area: business?.business_Area || "",
        business_city: business?.business_city || business?.business_Area || "",
        business_pincode: business?.business_pincode || "",
      });
    }
  }, [business]);

  const handleBusinessInputChange = (e) => {
    const { name, value } = e.target;
    setBusinessData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveBusiness = async (e) => {
    if (e) e.preventDefault();
    if (!userId) {
      toast.error("User ID not found");
      return;
    }
    setIsSaving(true);
    try {
      const res = await updateUser(userId, {
        shop_name: businessData.shop_name,
        business_Address: businessData.business_Address,
        business_Area: businessData.business_Area,
        business_city: businessData.business_city,
        business_pincode: businessData.business_pincode,
      });

      if (
        res?.statusCode == "200" ||
        res?.status_Code == "200" ||
        res?.status === 200 ||
        res?.data?.statusCode == "200"
      ) {
        toast.success("Business details updated successfully!");
        setIsEditing(false);
        if (typeof refreshData === "function") {
          refreshData();
        }
      } else {
        toast.error(res?.message || "Failed to update business details");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update business details"
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    if (business) {
      setBusinessData({
        shop_name: business?.shop_name || "",
        business_Address: business?.business_Address || "",
        business_Area: business?.business_Area || "",
        business_city: business?.business_city || business?.business_Area || "",
        business_pincode: business?.business_pincode || "",
      });
    }
    setIsEditing(false);
  };

  const getUserType = async () => {
    const res = await listUserType();
    const resZone = await getZoon();
    setData(resZone?.data);
    setuserData(res?.data);
  };

  useEffect(() => {
    getUserType();
  }, []);

  return (
    <>
      <Formik
        initialValues={value}
        validate={validate}
        className="tbl-captionn"
        enableReinitialize
      >
        {(formik) => {
          const {
            values,
            handleChange,
            handleSubmit,
            errors,
            touched,
            handleBlur,
          } = formik;
          return (
            <>
              {value?.gst && (
                <form className="tbl-captionn mb-4" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-4 mb-3">
                      <CustomInputField
                        type="text"
                        placeholder="GST Number "
                        value={values?.gst?.GSTIN}
                        hasError={errors.gst && touched.gst}
                        onChange={handleInput_A}
                        onBlur={handleBlur}
                        errorMsg={errors.gst}
                        id="gst"
                        name="gst"
                      />
                      <span
                        className="text-white position-relative rounded"
                        style={{
                          bottom: "34px",
                          left: "280px",
                          padding: "2px  8px",
                          display: "inline-block",
                          backgroundColor: `${
                            values?.is_gst === true ? "green" : "red"
                          }`,
                        }}
                      >
                        {values?.is_gst === true ? "Verify ✅" : "Not Verify ❎"}
                      </span>
                    </div>
                    <div className="col-xl-4 mb-3">
                      <CustomInputField
                        type="text"
                        placeholder="Name "
                        value={values?.name}
                        hasError={errors.name && touched.name}
                        onChange={handleInput_A}
                        onBlur={handleBlur}
                        errorMsg={errors.name}
                        autoFocus={true}
                        id="name"
                        name="name"
                      />
                    </div>
                    <div className="col-xl-4 mb-3">
                      <CustomInputField
                        type="text"
                        placeholder="GST Type "
                        value={values?.gstType}
                        hasError={errors.gstType && touched.gstType}
                        onChange={handleInput_A}
                        onBlur={handleBlur}
                        errorMsg={errors.gstType}
                        autoFocus={true}
                        id="GST Type"
                        name="GST Type"
                      />
                    </div>
                    <div className="col-xl-4 mb-3">
                      <CustomInputField
                        type="text"
                        placeholder="Shop Name "
                        value={values?.shop_name}
                        hasError={errors.shop_name && touched.shop_name}
                        onChange={handleInput_A}
                        onBlur={handleBlur}
                        errorMsg={errors.shop_name}
                        autoFocus={true}
                        id="Shop Name"
                        name="Shop Name"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <CustomTextArea
                        placeholder=" Address "
                        value={values?.gst?.principal_place_address}
                        onChange={handleInput_A}
                        onBlur={handleBlur}
                        autoFocus={false}
                        rows="6"
                        id="officeAddress"
                        name="officeAddress"
                      />
                    </div>
                  </div>
                </form>
              )}

              <section className="ListDistributer exppdf">
                <div className="row m-4">
                  <div className="col-xl-12">
                    <div className="card shadow-sm">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                          <div className="tbl-caption d-flex justify-content-between align-items-center p-3 border-bottom">
                            <h4 className="heading mb-0">
                              <b>Business Details</b>
                            </h4>
                            <div>
                              {!isEditing ? (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() => setIsEditing(true)}
                                >
                                  Edit Business Details
                                </button>
                              ) : (
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm me-2"
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={handleSaveBusiness}
                                    disabled={isSaving}
                                  >
                                    {isSaving ? "Saving..." : "Save Changes"}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>

                          {!isEditing ? (
                            <div
                              id="empoloyees-tblwrapper_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="table-to-xls"
                                className="table dataTable no-footer"
                                role="grid"
                              >
                                <thead>
                                  <tr role="row">
                                    <p>
                                      <th style={{ width: "200px" }}>
                                        Business Address
                                      </th>
                                      <td style={{ width: "200px" }}>
                                        {business?.business_Address || "N/A"}
                                      </td>
                                    </p>
                                    <p>
                                      <th style={{ width: "200px" }}>
                                        Business Area
                                      </th>
                                      <td style={{ width: "200px" }}>
                                        {business?.business_Area || "N/A"}
                                      </td>
                                    </p>
                                    <p>
                                      <th style={{ width: "200px" }}>
                                        Business City
                                      </th>
                                      <td style={{ width: "200px" }}>
                                        {business?.business_city ||
                                          business?.business_Area ||
                                          "N/A"}
                                      </td>
                                    </p>
                                    <p>
                                      <th style={{ width: "200px" }}>
                                        Business Pin Code
                                      </th>
                                      <td style={{ width: "200px" }}>
                                        {business?.business_pincode || "N/A"}
                                      </td>
                                    </p>
                                    <p>
                                      <th style={{ width: "200px" }}>
                                        Shop Name
                                      </th>
                                      <td style={{ width: "200px" }}>
                                        {business?.shop_name || "N/A"}
                                      </td>
                                    </p>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          ) : (
                            <div className="p-4">
                              <form onSubmit={handleSaveBusiness}>
                                <div className="row">
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">
                                      Shop Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="shop_name"
                                      value={businessData.shop_name}
                                      onChange={handleBusinessInputChange}
                                      placeholder="Enter shop name"
                                    />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">
                                      Business Pin Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="business_pincode"
                                      value={businessData.business_pincode}
                                      onChange={handleBusinessInputChange}
                                      placeholder="Enter pin code"
                                    />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">
                                      Business Area
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="business_Area"
                                      value={businessData.business_Area}
                                      onChange={handleBusinessInputChange}
                                      placeholder="Enter business area"
                                    />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">
                                      Business City
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="business_city"
                                      value={businessData.business_city}
                                      onChange={handleBusinessInputChange}
                                      placeholder="Enter business city"
                                    />
                                  </div>
                                  <div className="col-md-12 mb-3">
                                    <label className="form-label fw-bold">
                                      Business Address
                                    </label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      name="business_Address"
                                      value={businessData.business_Address}
                                      onChange={handleBusinessInputChange}
                                      placeholder="Enter business address"
                                    />
                                  </div>
                                </div>
                                <div className="d-flex justify-content-end gap-2 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSaving}
                                  >
                                    {isSaving ? "Saving..." : "Save Changes"}
                                  </button>
                                </div>
                              </form>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          );
        }}
      </Formik>
    </>
  );
}

export default BasicDetails;
